import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  list: [],
  total: 0,
  detail: {},
  error: null,
};

const travelTypeSlice = createSlice({
  name: "travelType",
  initialState,
  reducers: {
    // GET LIST
    getTravelTypeListRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getTravelTypeListSuccess: {
      reducer: (state, action) => {
        const { docs, totalDocs } = action.payload;
        return {
          ...state,
          isLoading: false,
          list: docs || [],
          total: totalDocs || 0,
          error: null,
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getTravelTypeListFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // GET ALL (No pagination)
    getTravelTypeAllRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getTravelTypeAllSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        list: action.payload || [],
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getTravelTypeAllFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // CREATE
    createTravelTypeRequest: {
      reducer: (state) => ({
        ...state,
        isCreating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createTravelTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isCreating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createTravelTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isCreating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // UPDATE
    updateTravelTypeRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateTravelTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateTravelTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // DELETE
    deleteTravelTypeRequest: {
      reducer: (state) => ({
        ...state,
        isDeleting: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteTravelTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isDeleting: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    deleteTravelTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isDeleting: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // RESTORE
    restoreTravelTypeRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    restoreTravelTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    restoreTravelTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
  },
});

export const {
  getTravelTypeListRequest,
  getTravelTypeListSuccess,
  getTravelTypeListFailure,
  getTravelTypeAllRequest,
  getTravelTypeAllSuccess,
  getTravelTypeAllFailure,
  createTravelTypeRequest,
  createTravelTypeSuccess,
  createTravelTypeFailure,
  updateTravelTypeRequest,
  updateTravelTypeSuccess,
  updateTravelTypeFailure,
  deleteTravelTypeRequest,
  deleteTravelTypeSuccess,
  deleteTravelTypeFailure,
  restoreTravelTypeRequest,
  restoreTravelTypeSuccess,
  restoreTravelTypeFailure,
} = travelTypeSlice.actions;

export default travelTypeSlice.reducer;